import React from 'react'
import './menu.scss'

import { Link } from "react-router-dom"

import dashboardIcon from '../../assets/svg/dashboardIcon.svg'
import resurantIcon from '../../assets/svg/resturantIcon.svg'
import categoryIcon from '../../assets/svg/categoryIcon.svg'
import foodIcon from '../../assets/svg/foodIcon.svg'
import grIcon from '../../assets/svg/qrIcon.svg'
import orderIcon from '../../assets/svg/orderIcon.svg'
import offIcon from '../../assets/svg/offIcon.svg'
import serverIcon from '../../assets/svg/serverIcon.svg'
import userIcon from '../../assets/svg/userIcon.svg'
import supportIcon from '../../assets/svg/supportIcon.svg'
import sliderIcon from '../../assets/svg/sliderIcon.svg'
import fileIcon from '../../assets/svg/fileIcon.svg'
import exitIcon from '../../assets/svg/exitIcon.svg'

export default function index({ page, badgeCountDashboard, badgeCountOrder }) {
  return (
    <aside id='aside'>
      {/* item */}
      <Link to='/dashboard' className='column'>
        <div className={page === 'dashboard' ? 'row active' : 'row'}>
          <img src={dashboardIcon} alt='' />
          <span>
            داشـبورد
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        رستوران شما
        <hr style={{ width: '65%' }} />
      </div>
      {/* item */}
      <Link to='/resturants' className='column'>
        <div className={page === 'resturant' ? 'row active' : 'row'}>
          <img src={resurantIcon} alt='' />
          <span>
            رستوران یا کافی‌شاپ
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/categories' className='column'>
        <div className={page === 'category' ? 'row active' : 'row'}>
          <img src={categoryIcon} alt='' />
          <span>
            دسته بندی
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/foods' className='column'>
        <div className={page === 'food' ? 'row active' : 'row'}>
          <img src={foodIcon} alt='' />
          <span>
            غذاها یا نوشیدنی‌ها
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/qr' className='column'>
        <div className={page === 'qr' ? 'row active' : 'row'}>
          <img src={grIcon} alt='' />
          <span>
            کد QR
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        حسابداری
        <hr style={{ width: '69%' }} />
      </div>
      {/* item */}
      <Link to='/orders' className='column'>
        <div className={page === 'order' ? 'row active' : 'row'}>
          <img src={orderIcon} alt='' />
          <span>
            سفارش‌ها
          </span>
          <span className='badge'>
            {badgeCountOrder}
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/offs' className='column'>
        <div className={page === 'offcode' ? 'row active' : 'row'}>
          <img src={offIcon} alt='' />
          <span>
            کد تخفیف
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        مدیریت 
        <hr style={{ width: '74%' }} />
      </div>
      {/* item */}
      <Link to='/servers' className='column'>
        <div className={page === 'server' ? 'row active' : 'row'}>
          <img src={serverIcon} alt='' />
          <span>
            گارسون و میزها
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/supports' className='column'>
        <div className={page === 'support' ? 'row active' : 'row'}>
          <img src={supportIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            پشتیبانی
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/users' className='column'>
        <div className={page === 'user' ? 'row active' : 'row'}>
          <img src={userIcon} alt='' />
          <span>
            کاربران
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        اسلایدر 
        <hr style={{ width: '74%' }} />
      </div>
      {/* item */}
      <Link to='/files' className='column'>
        <div className={page === 'files' ? 'row active' : 'row'}>
          <img src={fileIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            فایل
          </span>
        </div>
      </Link>
      <Link to='/sliders' className='column'>
        <div className={page === 'slider' ? 'row active' : 'row'}>
          <img src={sliderIcon} alt='' />
          <span>
            اسلایدر
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        سفارشات
        <hr style={{ width: '74%' }} />
      </div>
      {/* title */}
      <Link to='/orders/all' className='column'>
        <div className={page === 'allorder' ? 'row active' : 'row'}>
          <img src={orderIcon} alt='' />
          <span>
            کل سفارشات
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/orders/analytics' className='column'>
        <div className={page === 'analyticorder' ? 'row active' : 'row'}>
          <img src={orderIcon} alt='' />
          <span>
            آمار سفارشات
          </span>
        </div>
      </Link>
      <button style={{ borderRadius: '5px', backgroundColor: '#f0faff', color: '#111F3E' }}>ثبت سـفارش جـدید</button>
      {/* supprot */}
      <Link href='##'>
        <div className='support'>
          <span>
            +
          </span>
          <span>
            تماس با پشتیبانی
          </span>
          <span>
            5719 3559 - 041   
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/' className='column'>
        <div className={page === 'exit' ? 'row active' : 'row'}>
          <img src={exitIcon} alt='' />
          <span>
            خروج
          </span>
        </div>
      </Link>
    </aside>
  )
}
